import React from 'react';
import { ParallaxProvider as ParallaxProviderOrig } from 'react-scroll-parallax';
import { IS_CLIENT } from '../../config/constants';

// The original ParallaxProvider does not work properly with SSR, so wrap it.
const ParallaxProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  if (IS_CLIENT) {
    return (
      <ParallaxProviderOrig>{ children }</ParallaxProviderOrig>
    );
  }

  return children;
};

export default ParallaxProvider;
